import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function ViewDriver() {
   const navigate = useNavigate();
   const { id } = useParams();
   const [driver, setdriver] = useState(null);

   useEffect(() => {
      const fetchDriver = async () => {
         try {
            const res = await axios.get(`/auth/redem-drivers/${id}`);
            setdriver(res.data);
         } catch (err) {
            console.error("Error fetching driver details:", err);
         }
      };
      fetchDriver();
   }, [id]);

   if (!driver) {
      return <div className="p-6 text-gray-500 text-center">Loading driver details...</div>;
   }

   return (
      <section className="px-4 sm:px-6 lg:px-8 py-8 bg-gray-50 flex justify-center items-center min-h-screen">
         <div className="bg-white max-w-5xl w-full mx-auto p-6 sm:p-8 rounded-2xl shadow-2xl">

            <h1 className="text-3xl font-extrabold text-center text-green-700 mb-10">
               Driver Profile
            </h1>

            <div className="grid gap-4">
               <div className="grid gap-6">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-6 mb-6">
                     <div className="inline-block bg-green-100 text-green-700 font-semibold px-4 py-1 rounded-full text-sm shadow-sm">
                        {driver.accountNumber}
                     </div>

                     <div>
                        <h2 className="text-xl font-semibold text-green-800">Driver Details</h2>
                        <p className="text-sm text-gray-500">View detailed driver information</p>
                     </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-4">
                     <Info label="First Name" value={driver.first_name} />
                     <Info label="Last Name" value={driver.last_name} />
                     <Info label="Email" value={driver.email} />
                     <Info label="Phone" value={driver.phone} />
                     <Info
                        label="Date of Birth"
                        value={new Date(driver.dob).toLocaleDateString("en-US", {
                           year: "numeric",
                           month: "long",
                           day: "numeric",
                        })}
                     />
                     <Info label="Country" value={driver.country} />
                     <Info label="Street Address" value={driver.address} />
                     <Info label="City" value={driver.city} />
                     <Info label="Borough" value={driver.borough} />
                     <Info label="State" value={driver.state} />
                     <Info label="Zip Code" value={driver.zip} />
                     <Info label="Driver License No" value={driver.license_number} />
                     <Info label="License Plate No" value={driver.license_plate} />
                     <Info label="Vehicle Brand" value={driver.vehicle_brand} />
                     <Info label="Vehicle Model" value={driver.vehicle_model} />
                     <Info label="Vehicle Year" value={driver.vehicle_year} />
                     <Info label="Vehicle Color" value={driver.vehicle_color} />
                     <Info label="Payment Method" value={driver.payment_method} />
                     <Info label="Payment Email or Mobile Phone Number" value={driver.paymentContact} />
                     <Info label=" Redemption Center Name" value={driver.center_name} />
                  </div>
               </div>
            </div>

            <div className="flex justify-end mt-10">
               <button
                  onClick={() => navigate("/redem-driverlist")}
                  className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
               >
                  Back to List
               </button>
            </div>
         </div>
      </section>
   );
}

function Info({ label, value }) {
   return (
      <div className="text-gray-700">
         <span className="font-semibold">{label}:</span> {value}
      </div>
   );
}
